function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { PropertyGrid } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { DragDropView, ModelEditorFactory, Toolbar, useSharedContext } from '@leverege/ui-plugin';
import { RuleModel } from '@leverege/condition';
import S from './ObjectizerEditor.css';
const RuleMatches = {
  client: 'condition.ObjectizerEditor',
  use: 'ruleActionBar'
};
export default function RuleRow(props) {
  const {
    objectizerType = 'objectizer',
    onDrop,
    onRemove,
    index,
    conditionLabel,
    valueLabel,
    valueEditor: ValueEditor,
    valueProps,
    value
  } = props;
  const {
    conditionOptions,
    conditionCreators
  } = useSharedContext();
  const onChange = useValueChange(RuleModel, props);
  const ruleCondition = RuleModel.getCondition(value);
  const ruleValue = RuleModel.getValue(value);
  const cProps = {
    value: ruleCondition,
    eventData: 'setCondition',
    onChange
  };
  const conditionEditor = ModelEditorFactory.create(ruleCondition, cProps);
  return /*#__PURE__*/React.createElement(DragDropView, {
    accept: objectizerType,
    dragType: objectizerType,
    onDrop: onDrop,
    onRemove: onRemove,
    value: value,
    index: index
  }, /*#__PURE__*/React.createElement("div", {
    className: S.rule
  }, /*#__PURE__*/React.createElement(PropertyGrid, null, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: conditionLabel
  }, conditionEditor), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: valueLabel
  }, /*#__PURE__*/React.createElement(ValueEditor, _extends({}, valueProps, {
    eventData: "setValue",
    onChange: onChange,
    value: ruleValue
  })))), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Toolbar, {
    variant: "conditionBar|actionBar",
    prefer: "icon",
    matchContext: RuleMatches,
    context: props
  }))));
}